var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlaylistActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.751495C6 0.0850962 6.79158 -0.234814 7.25576 0.196888L7.32617 0.271357L12.3262 6.27136L11.1738 7.23163L7.5 2.8235V17.7515V17.8495H7.49874C7.44676 19.8753 5.78829 21.5015 3.75 21.5015C1.67893 21.5015 0 19.8225 0 17.7515C0 15.6804 1.67893 14.0015 3.75 14.0015C4.5942 14.0015 5.37325 14.2804 6 14.7512V0.751495ZM3.75 15.5015C4.99264 15.5015 6 16.5088 6 17.7515C6 18.9941 4.99264 20.0015 3.75 20.0015C2.50736 20.0015 1.5 18.9941 1.5 17.7515C1.5 16.5088 2.50736 15.5015 3.75 15.5015ZM20.4288 8.91493L19.9158 7.50539L10.049 11.0966L10.562 12.5061L20.4288 8.91493ZM19.9158 11.5054L20.4288 12.9149L10.562 16.5061L10.049 15.0966L19.9158 11.5054ZM20.4288 16.9149L19.9158 15.5054L10.049 19.0966L10.562 20.5061L20.4288 16.9149Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaylistActivity);
export default __webpack_public_path__ + "static/media/icon-playlist-activity.f7a3704e.svg";
export { ForwardRef as ReactComponent };